import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface SimpleLanguageReturn {
  language: string
  isRTL: boolean
  t: (key: string) => string
  i18n: any
}

/**
 * Lightweight language hook for public pages (login, etc.)
 * Does NOT use Redux - prevents loading entire Redux store on login page
 * Only uses i18n directly for minimal bundle size
 */
export const useSimpleLanguage = (namespace: string = 'translation'): SimpleLanguageReturn => {
  const { t, i18n } = useTranslation(namespace)
  
  const isRTL = ['fa', 'ps', 'ar'].includes(i18n.language)

  // Apply language changes to DOM (minimal side effect)
  useEffect(() => {
    document.documentElement.lang = i18n.language
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    document.body.dir = isRTL ? 'rtl' : 'ltr'
  }, [i18n.language, isRTL])

  return {
    language: i18n.language,
    isRTL,
    t,
    i18n,
  }
}

// Enable why-did-you-render tracking for this hook
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  try {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    
    // Track this hook's re-renders
    (useSimpleLanguage as any).whyDidYouRender = true;
    
    console.log('🔍 useSimpleLanguage hook tracking enabled');
  } catch (error) {
    console.warn('why-did-you-render failed to load for useSimpleLanguage:', error);
  }
}
